<template>
  <div class="p-input-component">
    <div class="d-flex align-items-center">
      <div
        v-if="required"
        class="required-dot"
      />
      <label
        :for="id"
        class="form-label"
        v-bind="labelElProps"
      >
        {{ label }}
      </label>
    </div>
    <select
      :id="id"
      class="form-select"
      :value="value"
      v-bind="selectInputProps"
      :required="required"
      @change="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
      :disabled="disabled"
    >
      <option value="">Select</option>
      <option
        v-for="(item, index) in items"
        :key="`${getItemValue(item)}-${index}`"
        :value="getItemValue(item)"
      >
        <template v-if="hasLabelSlot">
          <slot
            name="item-label"
            v-bind="item"
          />
        </template>
        <template v-else>
          {{ getItemLabel(item) }}
        </template>
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'PSelect',
  props: {
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    labelElProps: {
      type: Object,
      default: () => {}
    },
    selectInputProps: {
      type: Object,
      default: () => {}
    },
    label: {
      type: String,
      default: '',
      required: true
    },
    items: {
      type: Array,
      default: () => [],
      required: true
    },
    itemValue: {
      type: [String, Number],
      default: ''
    },
    itemLabel: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    hasLabelSlot () {
      return !!this.$scopedSlots['item-label']
    }
  },
  methods: {
    getItemValue (item) {
      if (typeof item !== 'object') return item
      return !this.itemValue ? item.value : item[this.itemValue]
    },
    getItemLabel (item) {
      if (typeof item !== 'object') return item
      return !this.itemLabel ? item.label : item[this.itemLabel]
    }
  }
}
</script>
